import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9428 7.40585C14.6486 7.01075 14.1973 6.7836 13.7044 6.7836H13.4367V5.58319C13.4367 3.91761 12.0817 2.56254 10.4161 2.56254H7.3616C7.26856 2.56254 7.17431 2.54019 7.09155 2.49911L5.18552 1.54579C4.93541 1.42074 4.65509 1.35489 4.37478 1.35489H3.16652C1.83381 1.35429 0.75 2.43809 0.75 3.7708V11.6245C0.75 13.2901 2.10506 14.6451 3.77065 14.6451H11.3573C12.7021 14.6451 13.8644 13.78 14.2583 12.466L15.1839 8.77119C15.3252 8.29876 15.237 7.80156 14.9428 7.40585ZM1.95826 11.6245V3.7708C1.95826 3.10445 2.50016 2.56254 3.16652 2.56254H4.37478C4.46781 2.56254 4.56206 2.5849 4.64482 2.62598L6.55085 3.57929C6.80096 3.70435 7.08128 3.7702 7.3616 3.7702H10.4161C11.4153 3.7702 12.2285 4.58336 12.2285 5.58259V6.78299H5.95458C4.92756 6.78299 4.01049 7.43485 3.66553 8.42623L2.34249 12.7385C2.10204 12.431 1.95826 12.0444 1.95826 11.6245ZM14.0191 8.451L13.0936 12.1452C12.8616 12.9179 12.1638 13.4369 11.3573 13.4369H3.77065C3.64499 13.4369 3.52235 13.4242 3.40394 13.3994L4.81398 8.8026C4.98253 8.31748 5.44167 7.99186 5.95518 7.99186H13.705C13.8512 7.99186 13.9363 8.07644 13.9738 8.12718C14.0113 8.17793 14.068 8.28365 14.0191 8.451Z"
      fill="white"
    />
  </svg>
);

const FolderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default FolderIcon;
